import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn/ui's canonical class-merging helper. Use it whenever you compose
 * tailwind class strings — it dedupes conflicting utilities so the last
 * one wins (e.g. `cn("px-2", isWide && "px-4")` → `"px-4"`).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
